module.exports = __webpack_public_path__ + "static/media/pin_cluster.9bf77b45.svg";